// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { TCApiGatewayControllersModelsClsInboundAddress } from './tCApiGatewayControllersModelsClsInboundAddress.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class TCApiGatewayControllersModelsClsInboundHco {
    'hcoName'?: string | null;
    'status'?: string | null;
    'accountType'?: string | null;
    'subType'?: string | null;
    'npi'?: string | null;
    'ncpcd'?: string | null;
    'hcoAddress'?: Array<TCApiGatewayControllersModelsClsInboundAddress> | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof TCApiGatewayControllersModelsClsInboundHco>> = [
        {
            "name":     "hcoName",
            "baseName": "hcoName",
            "type":     "string"
        },
        {
            "name":     "status",
            "baseName": "status",
            "type":     "string"
        },
        {
            "name":     "accountType",
            "baseName": "accountType",
            "type":     "string"
        },
        {
            "name":     "subType",
            "baseName": "subType",
            "type":     "string"
        },
        {
            "name":     "npi",
            "baseName": "npi",
            "type":     "string"
        },
        {
            "name":     "ncpcd",
            "baseName": "ncpcd",
            "type":     "string"
        },
        {
            "name":     "hcoAddress",
            "baseName": "hcoAddress",
            "type":     "Array<TCApiGatewayControllersModelsClsInboundAddress>"
        },
    ];

    static getAttributeTypeMap() {
        return TCApiGatewayControllersModelsClsInboundHco.attributeTypeMap;
    }
}
